// extracted by mini-css-extract-plugin
export default {"moreInfo":"styles_moreInfo__ByGsG","image":"styles_image__Mx3vC"};